import { createPivotTransformer } from './create-pivot-transformer';

const M3H_PER_L_MIN_OR_SLPM = 0.06;
const M3H_PER_CFM = 1.69901;

/** Pivot = m³/h. Actual volume flow — not interchangeable with standard/normal variants. */
export const VOLUME_FLOW_PIVOT: Record<string, number> = {
  'm3/h': 1,
  gpm: 0.227125,
  gpd: 0.000157725,
  'ml/min': 6e-5,
  'l/min': M3H_PER_L_MIN_OR_SLPM,
  'l/d': M3H_PER_L_MIN_OR_SLPM / 1440,
  cfm: M3H_PER_CFM,
};

/**
 * Pivot = m³/h. Standard/normal volume flow at reference conditions.
 * Not interchangeable with actual volume flow (cfm vs scfm, m3/h vs Nm3/h).
 */
export const STANDARD_VOLUME_FLOW_PIVOT: Record<string, number> = {
  scfm: M3H_PER_CFM,
  'nm3/h': 1,
  slpm: M3H_PER_L_MIN_OR_SLPM,
};

export const transformVolumeFlow = createPivotTransformer(VOLUME_FLOW_PIVOT);
export const transformStandardVolumeFlow = createPivotTransformer(STANDARD_VOLUME_FLOW_PIVOT);
